import React from "react";
import Flx from "../../../components/layout/Flx";
import PublicFormGrid from "../../../components/publicForm/PublicFormGrid";
import PublicFormSection from "../../../components/publicForm/PublicFormSection";
import RffFileUploadField from "../../../components/finalForm/inputs/RffFileUploadField";

/** Step 2 — photo ID. */
const StepCreditAuthIdentification = () => (
  <Flx column>
    <PublicFormSection
      title="Photo Identification"
      description="A driver's license or passport. Please upload both the front and the back — make sure all four corners are visible and the text is legible."
    >
      <PublicFormGrid>
        <RffFileUploadField
          required
          label="Upload Photo Identification"
          docGroup="Borrower Documents"
          docType="Photo Identification"
          helperText="You can add more than one file."
        />
      </PublicFormGrid>
    </PublicFormSection>
  </Flx>
);

export default StepCreditAuthIdentification;
